import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";
import type { DeliveryStatus } from "@/types/api";

const STYLES: Record<DeliveryStatus, { pill: string; dot: string }> = {
  PENDING: { pill: "bg-warning-soft text-warning", dot: "bg-warning animate-pulse-ring" },
  SENT: { pill: "bg-success-soft text-success", dot: "bg-success" },
  READ: { pill: "bg-tile-sky text-tile-sky-strong", dot: "bg-tile-sky-strong" },
  FAILED: { pill: "bg-destructive/10 text-destructive", dot: "bg-destructive" },
  SKIPPED: { pill: "bg-muted text-muted-foreground", dot: "bg-muted-foreground" },
};

export function DeliveryStatusBadge({ status }: { status: DeliveryStatus }) {
  const { t } = useTranslation();
  const style = STYLES[status];
  return (
    <span
      className={cn(
        "inline-flex h-6 items-center gap-1.5 rounded-full px-2 text-xs font-medium",
        style.pill,
      )}
    >
      <span className={cn("size-1.5 rounded-full", style.dot)} />
      {t(`deliveries.statuses.${status}`)}
    </span>
  );
}
